import { BasePageModel } from 'models/BasePageModel';
import { ILocation } from 'models/ILocation';
import { IMenuItem } from 'models/IMenuItem';
import { PageState } from 'models/PageState';
import { hasElements } from 'utils';

export const getCurrentCategoryName = ({ breadCrumbs }: BasePageModel) => {
  if (breadCrumbs === undefined || breadCrumbs.length === 0) {
    return '';
  }
  return breadCrumbs[breadCrumbs.length - 1].title;
};

const pages = ['sok', 'search'];

export const shouldShowBreadcrumbs = (location: ILocation, breadcrumbs?: IMenuItem[]) =>
  pages.some(p => location.pathname.includes(p)) || hasElements(breadcrumbs);

export const getBreadCrumbs = (currentPage: BasePageModel) => currentPage.breadCrumbs || [];
export const breadCrumbsSelector = (state: PageState) => state.currentPage.breadCrumbs || [];

export const channel = (state: PageState) => state.appShell.channel;
export const componentName = (state: PageState) => state.currentPage.componentName;
